import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiConfig } from 'src/app/utility/ApiConfig';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
declare function setDatatableSearch(): any;

@Component({
  selector: 'app-balance-sheet',
  templateUrl: './balance-sheet.component.html',
  styleUrls: ['./balance-sheet.component.sass']
})
export class BalanceSheetComponent implements OnInit {

  httpOptions: any = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'token': this.ApiConfig.USER_DATA.token })
  };
  responseApi: any;
  tempStoreData: any;
  
  firstTime: boolean = true;

  balanceSheetForm = new FormGroup({
    storeId   : new FormControl('', [Validators.required]),
    storeName : new FormControl('', [Validators.required]),
    datePeriod: new FormControl('', [Validators.required]),
  });

  constructor(
    private ApiConfig: ApiConfig,
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.getStore();
  }

  getStore(){
    this.http.get(this.ApiConfig.API_URL + "/store", this.httpOptions).subscribe(
      res => {
        this.responseApi = res;
        this.tempStoreData = this.responseApi.data.map(store => ({
          "id": store.id_store,
          "text": store.store_name,
          "additional": store
        }));

        this.tempStoreData.push({
          "id" : 'all',
          "text" : 'All',
          "additional" : 'all',
        });
      }
    )
  };

  changeStore(event: any){
    if (!this.firstTime){
      this.balanceSheetForm.patchValue({
        storeId   : event,
        storeName : this.tempStoreData.find(element => element.id == event).text,
      });
    } else {
      this.firstTime = false;
    }
  };

  generateBalanceSheet(){
    this.http.post(this.ApiConfig.API_URL + "/generate/balance-sheet", this.balanceSheetForm.value, this.httpOptions).subscribe((res) => {
      this.responseApi = res;
      if (this.responseApi.status == "200"){
        window.open(
          this.ApiConfig.API_URL + "/open-report?directory=" + this.responseApi.data.directory + "&pdfName=" + this.responseApi.data.name
        );
      }
    });
  }

}
